<template>
  <div class="supervise-detail">
    <div class="patient_list">

            <van-cell-group inset class="cell-group" v-for="Ditem,index in item.detail" :key="index">
                <van-cell  :border="false">
                    <template #title><div class="grey_label">省份城市:</div></template>   
                    <div>{{item.province}}{{item.city}}</div>
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">药房名称:</div></template>      
                    <div>{{item.drugstore_name}}</div> 
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">盘点日期:</div></template>      
                    <div>{{item.take_date}}</div> 
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">药品名称:</div></template>      
                    <div>{{item.drug_name}}</div> 
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">药品规格:</div></template>      
                    <div>{{item.drug_specifications}}</div> 
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">药品批号:</div></template>      
                    <div>{{Ditem.sn}}</div> 
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">实盘数量:</div></template>      
                    <div>{{Ditem.quantity}}</div> 
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">现场照片:</div></template>
                    <template #default>
                        <div v-for="img,i in item.images" :key="i">
                            <van-image width="10rem" height="10rem" fit="contain" :src="img.filepath" @click="showPic(item.images,i)" />
                        </div>  
                    </template>
                </van-cell>
            </van-cell-group>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { List,ImagePreview } from 'vant';
import { Divider } from 'vant';
// import { mapMutations } from "vuex";
  import { 
  getDrugstoreTake
  } from '@/api/publicWelfareStaff' 
Vue.use(Divider);
Vue.use(List);
Vue.use(ImagePreview)
export default {
    data(){
        return {
            drugstore_take_id:'',
            item: {},
            // images:['https://img01.yzcdn.cn/vant/cat.jpeg'],
        }
    },
     computed: {
      
    },
    async created(){
        if(this.$route.query.drugstore_take_id) this.drugstore_take_id=this.$route.query.drugstore_take_id
        await this.init()
        console.log("库存盘点详情",this.item)

    },
    methods: {
    //   ...mapMutations(['setOriginRoute']),
        async init(){
            await getDrugstoreTake({drugstore_take_id:this.drugstore_take_id}).then(res => {
                console.log(res.data)
                if(res.data){
                    this.item=res.data
                }
            })
        },
        showPic(route, index) {
            console.log(route, index)
            this.src = []
            if (Array.isArray(route)) {
                route.forEach(ele => {
                    this.src.push(ele.filepath)
                })
            } else {
                this.src.push(route)
            }
            this.$nextTick(() => {
                ImagePreview({
                    images: this.src,
                    showIndex: true,
                    loop: false,
                    startPosition: index ? index : 0,
                })
            })
        },

    }
}
</script>

<style lang="scss" scoped>
.supervise-detail{
    min-height: 100vh;
    background-color: #F9F9F9 ;
    font-size: 16px;
    ::v-deep .grey_label{
        color:#9D9D9D;
        white-space:nowrap;
    }
    .van-search{
        padding:16px;
    }
    .van-cell-group {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    .patient_list{
    //   box-shadow: 0 -2px 6px rgba(73, 46, 46, 0.2);
      padding-bottom: 44px;
            padding-top:10px;

        .cell-group{
            margin-bottom:10px;
            .van-cell__title {
                flex: 1;
                text-align: right;
                margin-right: 10px;
            }
            .van-cell__value{
                flex: 3;
                color:#0A0A0A;
                white-space:nowrap;
                text-align: left;
                // display:flex;
                // justify-content:flex-start;
                // align-items:center;
            .alignment-flex{
                display:flex;
                justify-content:flex-start;
                align-items:flex-start;
            }
            }
        }
      
    }
}
</style>